import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

export default function FeaturedMovies() {
  const featured = movies.filter((m) => m.isHot || m.isNew).slice(0, 8);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 animate-slide-up">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-100">精选推荐</h2>
          <p className="text-foreground-500 text-sm mt-1">为您精选的高分热门影片</p>
        </div>
      </div>
      <div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5"
        data-product-shop
      >
        {featured.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}